async function requestJson(path, options = {}) {
  const response = await fetch(path, {
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(options.headers ?? {})
    },
    ...options
  });

  if (response.status === 204) {
    return null;
  }

  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(body.error || "Istek tamamlanamadi.");
  }

  return body;
}

export function login(email, password, turnstileToken) {
  return requestJson("/api/auth/login", {
    method: "POST",
    body: JSON.stringify({
      email,
      password,
      ...(turnstileToken ? { turnstileToken } : {})
    })
  });
}

export function logout() {
  return requestJson("/api/auth/logout", {
    method: "POST"
  });
}

export function getMe() {
  return requestJson("/api/auth/me");
}
